import React from "react";
import NextButton from "./NextButton";

const MobileFooter = ({ handlers, disableShowAlert }) => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        height: "80px",
        padding: "20px",
        background: "white",
        borderTop: "1px #E7E6EA solid",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "10px",
        zIndex: 1000
      }}
    >
      <NextButton disableShowAlert={disableShowAlert} handlers={handlers} />
    </div>
  );
};

export default MobileFooter;
